import { render, staticRenderFns } from "./activityOrdinary.vue?vue&type=template&id=7c7412f8&scoped=true&"
import script from "./activityOrdinary.vue?vue&type=script&lang=js&"
export * from "./activityOrdinary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7412f8",
  null
  
)

export default component.exports